import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AnnouncementBar() {
  const [msg, setMsg] = useState(
    "Handmade in India · Custom sizes available · Worldwide enquiries welcome"
  );
  useEffect(() => {
    api.get("/site-settings").then((r) => {
      if (r.data?.announcement_message) setMsg(r.data.announcement_message);
    }).catch(() => {});
  }, []);
  return (
    <div className="bg-[#1a1a1a] text-[#fbf9f5]" data-testid="v2-announcement-bar">
      <div className="max-w-[1440px] mx-auto px-4 md:px-8 py-2.5 text-center text-[11px] tracking-[0.24em] uppercase font-medium overflow-hidden">
        <span className="hidden md:inline">{msg}</span>
        <span className="md:hidden">{msg.split(" · ")[0] || msg}</span>
      </div>
    </div>
  );
}
